import React, { Fragment, ReactNode } from 'react';

export interface IErrorBoundary {
  children: ReactNode;
  errorComponent: ReactNode;
  hasError?: boolean;
}

const ErrorBoundary = ({ children, errorComponent, hasError = false }: IErrorBoundary) => {
  return <Fragment>{hasError ? errorComponent : children}</Fragment>;
};

export default ErrorBoundary;
